import { axiosGu, refreshTokenTimeouts } from 'config';
import { refreshToken } from 'services/authServices';

let isRefreshing = false;
let pendingQueue = [];

const flushQueue = (error) => {
    const queue = pendingQueue;
    pendingQueue = [];
    queue.forEach(({ resolve, reject, request }) => {
        if (error) {
            reject(error);
        } else {
            resolve(axiosGu.request(request));
        }
    });
};

const createTimeoutError = (timeoutMs) => {
    const timeoutError = new Error(`Refresh timeout after ${timeoutMs}ms`);
    timeoutError.isTimeout = true;
    return timeoutError;
};

const performRefreshWithTimeout = (timeoutMs) => {
    const refreshPromise = refreshToken();
    let timeoutId;

    const timeoutPromise = new Promise((_, reject) => {
        timeoutId = setTimeout(
            () => reject(createTimeoutError(timeoutMs)),
            timeoutMs
        );
    });

    return Promise.race([
        refreshPromise.finally(() => clearTimeout(timeoutId)),
        timeoutPromise,
    ]);
};

export const handleResponseInterceptorError = async (error) => {
    const status = error?.response?.status;
    const originalRequest = error?.config;
    const url = originalRequest?.url;

    if (status !== 401 && status !== 403) {
        return Promise.reject(error);
    }

    if (url === "/auth/refresh" || originalRequest?._retry) {
        globalThis.MyContextAPI.logOutHandler();
        return Promise.reject(error);
    }

    originalRequest._retry = true;

    if (isRefreshing) {
        return new Promise((resolve, reject) => {
            pendingQueue.push({ resolve, reject, request: originalRequest });
        });
    }

    isRefreshing = true;
    try {
        const attemptRefresh = async () => {
            try {
                return await performRefreshWithTimeout(refreshTokenTimeouts.initial);
            } catch (firstError) {
                if (firstError?.isTimeout) {
                    return await performRefreshWithTimeout(refreshTokenTimeouts.retry);
                }
                throw firstError;
            }
        };

        const refreshResponse = await attemptRefresh();
        if (refreshResponse?.status === 200) {
            const retried = axiosGu.request(originalRequest);
            isRefreshing = false;
            flushQueue(null);
            return retried;
        }
        globalThis.MyContextAPI.logOutHandler();
        flushQueue(new Error("Refresh failed"));
        return Promise.reject(error);
    } catch (refreshErr) {
        globalThis.MyContextAPI.logOutHandler();
        flushQueue(refreshErr);
        return Promise.reject(refreshErr);
    } finally {
        isRefreshing = false;
    }
};
